import React, { useState } from "react";
import "./Navbar.css";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <div className="navbar_main">
      <div className="navbar_logo">
        <Link to="/">
          <img src="/images/logo2.png" alt="logo" />
        </Link>
      </div>
      <div className={`link_items ${isOpen ? "open" : ""}`}>
        <Link to="/" className="link" onClick={closeMenu}>
          Home
        </Link>
        <Link to="/about" className="link" onClick={closeMenu}>
          About
        </Link>
        <Link to="/services" className="link" onClick={closeMenu}>
          Services
        </Link>
        <Link to="/products" className="link" onClick={closeMenu}>
          Products
        </Link>
        <Link to="/contact" className="link" onClick={closeMenu}>
          Contact
        </Link>
      </div>
      <div className="hamburger" onClick={toggleMenu}>
        ☰
      </div>
    </div>
  );
};

export default Navbar;
